import { render } from "./EditEmployeeAdvanceRequest.vue?vue&type=template&id=183957a6"
import script from "./EditEmployeeAdvanceRequest.vue?vue&type=script&lang=js"
export * from "./EditEmployeeAdvanceRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__